module.exports = __webpack_public_path__ + "static/assets/3cbe5be8dba7df255a9049fa3db394d4.gif";